import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import "./DateChangePreviewNext.scss";
import { useNavigate } from "react-router-dom";
import { fetchOneWayFlightList } from "../../../redux/flight/flightOneWaySlice";
import { useDispatch } from "react-redux";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const STORAGE_KEY = "DepartureFlight";
const DATE_FORMAT = "ddd, MMM DD";
const API_DATE_FORMAT = "DD/MMM/YYYY";

const DateChangePreviewNext = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const currentDate = dayjs().startOf("day");
    const nextDay = currentDate;

    const getStoredDate = () => {
        const storedDate = sessionStorage.getItem(STORAGE_KEY);
        const parsedDate = storedDate && dayjs(storedDate, API_DATE_FORMAT).isValid()
            ? dayjs(storedDate, API_DATE_FORMAT)
            : nextDay;

        return parsedDate.isBefore(nextDay, "day") ? nextDay : parsedDate;
    };

    const [selectedDate, setSelectedDate] = useState(getStoredDate());
    const [startDate, setStartDate] = useState(getStoredDate());
    const generateDateRange = (baseDate) => {
        return Array.from({ length: 7 }, (_, i) => baseDate.add(i, "day"));
    };

    const [dates, setDates] = useState(generateDateRange(startDate));

    useEffect(() => {
        setDates(generateDateRange(startDate));
    }, [startDate]);

    const getFromSessionStorage = (key, defaultValue = null) => {
        const value = sessionStorage.getItem(key);
        if (!value) return defaultValue;
        try {
            return JSON.parse(value);
        } catch (e) {
            console.error(`Error parsing SessionStorage key "${key}":`, e);
            return defaultValue;
        }
    };

    const flightData = {
        selectFromCity: getFromSessionStorage('selectFromCity'),
        selectTOCity: getFromSessionStorage('selectTOCity'),
        selectedFromCode: getFromSessionStorage("selectedFromCode"),
        selectedToCode: getFromSessionStorage("selectedToCode"),
        selectAdultsFlight: getFromSessionStorage("selectAdultsflight") || 1,
        selectChildFlight: getFromSessionStorage("selectChildflight") || 0,
        selectInfantsFlight: getFromSessionStorage("selectInfantsflight") || 0,
        seatTypeFlight: getFromSessionStorage("seatTypeflight"),
    };

    const fetchOneWayFlightUpdate = (newDate) => {
        const reqBody = {
            cabinClass: flightData?.seatTypeFlight || "ECONOMY",
            routeInfos: [
                {
                    fromCityOrAirport: { code: flightData?.selectedFromCode },
                    toCityOrAirport: { code: flightData?.selectedToCode },
                    travelDate: newDate.format("YYYY-MM-DD"),
                },
            ],
            paxInfo: {
                ADULT: flightData?.selectAdultsFlight.toString(),
                CHILD: flightData?.selectChildFlight.toString(),
                INFANT: flightData?.selectInfantsFlight.toString(),
            },
        };

        sessionStorage.setItem('selectFromCity', JSON.stringify(flightData?.selectFromCity));
        sessionStorage.setItem('selectTOCity', JSON.stringify(flightData?.selectTOCity));
        sessionStorage.setItem('selectAdultsFlight', JSON.stringify(flightData?.adultsCount));
        sessionStorage.setItem('selectChildrenFlight', JSON.stringify(flightData?.childrenCount));
        sessionStorage.setItem('selectInfantsFlight', JSON.stringify(flightData?.infantsCount));
        sessionStorage.setItem('seatTypeFlight', JSON.stringify(flightData?.cabinClass));
        sessionStorage.setItem('selectedFromCode', JSON.stringify(flightData?.selectedFromCode));
        sessionStorage.setItem('selectedToCode', JSON.stringify(flightData?.selectedToCode));
        const formattedFromCity = flightData?.selectFromCity?.toLowerCase().replace(/\s+/g, "-");
        const formattedToCity = flightData?.selectTOCity?.toLowerCase().replace(/\s+/g, "-");
        const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
        const resultUrl = `/flights/${urlIdDynamic}`;
        navigate(resultUrl);
        dispatch(fetchOneWayFlightList({ reqBody }));
        sessionStorage.removeItem("comeFromReview");
    };

    // const updateDate = (newDate) => {
    //     if (!newDate?.isValid() || newDate?.isBefore(nextDay, "day")) return;
    //     sessionStorage.setItem(STORAGE_KEY, newDate?.format(API_DATE_FORMAT));
    //     setSelectedDate(newDate);
    //     sessionStorage.setItem('findDayReturnFlight', JSON.stringify(newDate?.add(1, "day").format(API_DATE_FORMAT)));
    //     fetchOneWayFlightUpdate(newDate);
    //     window.dispatchEvent(new Event("storage"));

    //     setStartDate(newDate);
    // };

    const updateDate = (newDate) => {
        if (!newDate?.isValid() || newDate?.isBefore(nextDay, "day")) return;
        sessionStorage.setItem(STORAGE_KEY, newDate.format(API_DATE_FORMAT));
        const returnDate = newDate.clone().add(1, "day").format(API_DATE_FORMAT);
        sessionStorage.setItem("findDayReturnFlight", returnDate);
        setSelectedDate(newDate);
        setStartDate(newDate);
        window.dispatchEvent(new Event("storage"));
        fetchOneWayFlightUpdate(newDate);
    };

    const shiftDateRange = (direction) => {
        setStartDate((prev) => {
            const newStartDate = prev.add(direction === "next" ? 7 : -7, "day");
            return newStartDate.isBefore(nextDay, "day") ? nextDay : newStartDate;
        });
    };

    return (
        <div className="d-none d-md-block">
            <div className="date-price-carousel mb-2 ">
                <button
                    className="nav-button"
                    onClick={() => shiftDateRange("prev")}
                    disabled={startDate?.isSame(nextDay, "day")}
                    aria-label="shift previous day"
                >
                    <FaChevronLeft />
                </button>

                <div className="date-list">
                    {dates?.map((date, index) => (
                        <div
                            key={index}
                            className={`date-item ${date?.isSame(selectedDate, "day") ? "selected" : ""} ${date.isBefore(nextDay, "day") ? "disabled" : ""}`}
                            onClick={() => updateDate(date)}
                        >
                            <div>{date.format(DATE_FORMAT)}</div>
                        </div>
                    ))}
                </div>

                <button className="nav-button" onClick={() => shiftDateRange("next")} aria-label="shift next day">
                    <FaChevronRight />
                </button>

            </div>
        </div>
    );
};

export default DateChangePreviewNext;
